module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAMCAYAAAB4MH11AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAAAQ1JREFUeAGtk40NgjAQhVsmYARGwA10AmQC2ECcAJgAnECcAJhAN4ANZAQ2wHd4Jk3lp0aakF56997Xa4usquopMIZhOPi+34kNRlmWjpTyTrHFa+MCJcSfQzF3RgDtHHO7BQTaPTwaNn/Aeyc5YTPVxdchgdPy21/M67o+QZdTjPkGfUix1HZQABQg7PlOjCAwj1GfsHkKXfLJWWohUVFwQUgdNRAGBuaZYn5Wzb86UDpJAIgVUT5RQ5u4IjyKd8dUV+h1kwAdgjnxPC9VcvQgSmFwZ7OAOYj2DLu1/2cRwJAIhhlDchiGCG18Le+8W9KvAhgS8nmPg54hpgjm/ZrWCMAQl84d5jWMI1PdC8zIpZxox7ljAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/icn_expand_less.png
// module id = uY62
// module chunks = 1